module.exports = __webpack_public_path__ + "static/img/Team 4.9039444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hr/Team 4.png
// module id = hOkw
// module chunks = 2